import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { itemsApplications } from './itemsApplications';
import { ButtonWithRedirect } from '../../components/commons/ButtonWithRedirect/ButtonWithRedirect';
import { colors } from '../../constants/colors';

export const ApplicationsTemplate = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2} justifyContent="center" alignContent="center">
        <Grid item xs={10} md={8}>
          <Box
            sx={{ flexGrow: 1, border: `1px solid ${colors.lightGray}` }}
            marginTop={3}
          >
            <Grid container spacing={2} marginTop={2} alignItems="center">
              {itemsApplications.map((element) => (
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  lg={2.3}
                  key={Math.random()}
                  textAlign="center"
                >
                  <ButtonWithRedirect
                    icon={element.icon}
                    text={element.text}
                    url={element.url}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
